import {
    DataRequestRoutesComponent,
    DataRequestTabsComponent,
    RequestHeaderContainerComponent
} from '@vivli/features/data-requests/components';
import { DataRequestContext } from '@vivli/features/data-requests/infrastructure/context';
import { IDataRequest } from '@vivli/features/data-requests/infrastructure/interface';
import { DataRequestContextWrapper, StatusUpdateContextWrapper } from '@vivli/features/data-requests/infrastructure/wrappers';
import { NotificationContextWrapper } from '@vivli/shared/features/notification/infrastructure/wrappers';
import { LoadIndicatorCenteredView } from '@vivli/shared/views';
import { dataRequestShellBodyContainerStyle, dataRequestShellContainerStyle } from './data-request-shell.styles';
import { useActiveUserContext } from '@vivli/core/infrastructure/context';
import { useDataRequestForm } from '@vivli/features/data-requests/infrastructure/hook';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';
import { FormProvider } from 'react-hook-form';
import {useEffect} from "react";

interface DataRequestShellComponentProps {
    dataRequest: IDataRequest;
    isInPreviewMode?: boolean;
}

//this is a common feature used by the 2 data request features,
//standard feature that uses the GUID to fill the data request
//and vivli ID feature (for use with url access) that uses
//vivli ID to fill the data request.
export const DataRequestShellFeature = ({ dataRequest, isInPreviewMode = false }: DataRequestShellComponentProps) => {
    const { hasPermission } = useActiveUserContext();
    const formApi = useDataRequestForm(dataRequest, hasPermission(PermissionsEnum.DrActAdv));

    useEffect(() => {
        if (!dataRequest) return;

        formApi.reset(dataRequest);
    }, [dataRequest]);

    return (
        <div style={dataRequestShellContainerStyle}>
            <FormProvider {...formApi}>
                <DataRequestContextWrapper dataRequest={dataRequest}>
                    <DataRequestContext.Consumer>
                        {({ organizations }) => {
                            if (!organizations) {
                                return <LoadIndicatorCenteredView />;
                            }

                            return (
                                <StatusUpdateContextWrapper>
                                    <NotificationContextWrapper>
                                        <>
                                            {!isInPreviewMode && <RequestHeaderContainerComponent />}

                                            <div style={dataRequestShellBodyContainerStyle} className="do-not-print">
                                                {!isInPreviewMode && <DataRequestTabsComponent />}
                                                <DataRequestRoutesComponent />
                                            </div>
                                        </>
                                    </NotificationContextWrapper>
                                </StatusUpdateContextWrapper>
                            );
                        }}
                    </DataRequestContext.Consumer>
                </DataRequestContextWrapper>
            </FormProvider>
        </div>
    );
};
